import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Flex from "../../Misc/Flex";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import { Link } from "react-router-dom";
import PasswordChange from "./PasswordChange";
import ProfileAvatar from "./ProfileAvatar";

export default class Profile extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      pending: false,
      showPasswordModal: false,
      showAvatarModal: false,
    };
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    let user = this.context.user || {};
    let staff = user.staff || {};
    let email = "";
    let phone = "";

    if (staff.email && Array.isArray(staff.email)) {
      email = staff.email;
    }
    if (staff.phone) {
      phone = staff.phone.mobile;
    }

    this.setState({
      data: {
        email,
        phone,
      },
    });
  };

  save = async () => {
    this.setState({ pending: true });
    const user = this.context.user || {};
    const { data } = this.state;
    let saveData = {
      id: user.staffId,
      position: user.staff.position,
      email: [data.email],
      phone: { mobile: data.phone },
    };
    let result = await this.context.api.q("/staff/set", saveData);
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
    this.setState({ pending: false });
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let { data } = state;
      data[id] = value;
      return { data };
    });
  };

  togglePasswordModal = (showPasswordModal) => {
    this.setState({ showPasswordModal });
  };

  toggleAvatarModal = (showAvatarModal) => {
    this.setState({ showAvatarModal });
  };

  render() {
    const { data, pending, showPasswordModal, showAvatarModal } = this.state;
    let user = this.context.user || {};
    let show = user.show || {};

    const { passwordchange, passwordnotchange } = user.info.profile;
    return (
      <>
        <PasswordChange
          passwordchange={passwordchange}
          passwordnotchange={passwordnotchange}
          show={showPasswordModal}
          onClose={() => this.togglePasswordModal(false)}
        />
        <ProfileAvatar
          show={showAvatarModal}
          onClose={() => this.toggleAvatarModal(false)}
        />
        <CrumbsProvider title="Профиль" link="/profile/" />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="card card-custom gutter-b card-stretch">
                <div className="card-body">
                  <Blocker on={pending}>
                    <div className="border-bottom mb-5 pb-4">
                      <Flex>
                        <span
                          className="symbol symbol-100 symbol-light mr-5 cursor-pointer"
                          onClick={() => this.toggleAvatarModal(true)}
                        >
                          {show.picture ? (
                            <img alt="userpic" src={show.picture} />
                          ) : (
                            <span className="symbol-label font-weight-bold bg-primary-o-20 font-size-h1">
                              {show.literal}
                            </span>
                          )}
                        </span>
                        <div>
                          <h5>
                            {show.name}
                            {show.admin && (
                              <Link to="/admin/">
                                <span className="label label-success label-inline ml-2">
                                  Администратор
                                </span>
                              </Link>
                            )}
                          </h5>

                          {show.department && (
                            <div className="small text-dark-50 mt-1">
                              {show.department}
                            </div>
                          )}
                          {show.role && (
                            <div className="label label-inline mt-1">
                              {show.role}
                            </div>
                          )}
                        </div>
                      </Flex>
                    </div>

                    {passwordchange && !passwordnotchange && (
                      <div
                        onClick={() => this.togglePasswordModal(true)}
                        className="alert cursor-pointer mb-5 bg-light-warning text-warning"
                      >
                        Администратор установил для вас необходимость смены
                        пароля
                      </div>
                    )}

                    <div className="form-group">
                      <label>E-mail:</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={data.email || ""}
                        onChange={(e) => this.onChange("email", e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") this.save();
                        }}
                      />
                    </div>
                    <div className="form-group">
                      <label>Телефон:</label>
                      <input
                        type="text"
                        className="form-control mb-3"
                        value={data.phone || ""}
                        onChange={(e) => this.onChange("phone", e.target.value)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") this.save();
                        }}
                      />
                    </div>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary mr-2"
                        onClick={this.save}
                      >
                        Сохранить
                      </button>
                      {!passwordnotchange && (
                        <button
                          className={`btn mr-2 ${
                            passwordchange ? "btn-warning" : "btn-light"
                          }`}
                          onClick={() => this.togglePasswordModal(true)}
                        >
                          Сменить пароль
                        </button>
                      )}
                    </div>
                  </Blocker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
